import { render, staticRenderFns } from "./MyFavoritesView.vue?vue&type=template&id=4d2fc234&scoped=true"
import script from "./MyFavoritesView.vue?vue&type=script&lang=js"
export * from "./MyFavoritesView.vue?vue&type=script&lang=js"
import style0 from "./MyFavoritesView.vue?vue&type=style&index=0&id=4d2fc234&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2fc234",
  null
  
)

export default component.exports